var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ChatCTABody, ChatCTACard, IconWrapper } from './subcomponents';
const ChatCTA = (_a) => {
    var { children, onClick, color } = _a, props = __rest(_a, ["children", "onClick", "color"]);
    return (_jsxs(ChatCTACard, Object.assign({ color: color, onClick: onClick }, props, { children: [_jsx(IconWrapper, Object.assign({ color: color }, { children: _jsx(FontAwesomeIcon, { icon: ['fal', 'comments'], size: "3x" }) })), _jsx(ChatCTABody, { children: children })] })));
};
export default ChatCTA;
//# sourceMappingURL=ChatCTA.js.map